(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-contact')) {
    customElements.define('floating-contact', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        document.addEventListener('click', (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.summary.focus();
          }
        });
        this.querySelectorAll('[data-contact-action]').forEach((link) => {
          link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: `${link.dataset.contactAction}_click` });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductDetailsTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.normalizeDescriptionImages();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(index));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    normalizeDescriptionImages() {
      const panel = this.querySelector('.product-details-tabs__panel--description');
      if (!panel) return;

      const isFullWidth = this.classList.contains('product-details-tabs--images-full');
      const isContentWidth = this.classList.contains('product-details-tabs--images-content');
      if (!isFullWidth && !isContentWidth) return;

      panel.querySelectorAll('img').forEach((image) => {
        image.removeAttribute('width');
        image.removeAttribute('height');
        image.style.setProperty('display', 'block', 'important');
        image.style.setProperty('float', 'none', 'important');
        image.style.setProperty('height', 'auto', 'important');
        image.style.setProperty('object-fit', 'contain', 'important');

        if (isFullWidth) {
          image.style.setProperty(
            'width',
            'calc(100% + var(--tabs-panel-padding) + var(--tabs-panel-padding))',
            'important'
          );
          image.style.setProperty('max-width', 'none', 'important');
          image.style.setProperty('margin-left', 'calc(0px - var(--tabs-panel-padding))', 'important');
          image.style.setProperty('margin-right', 'calc(0px - var(--tabs-panel-padding))', 'important');
        } else {
          image.style.setProperty('width', '100%', 'important');
          image.style.setProperty('max-width', '100%', 'important');
          image.style.setProperty('margin-left', '0', 'important');
          image.style.setProperty('margin-right', '0', 'important');
        }

        let wrapper = image.parentElement;

        while (wrapper && wrapper !== panel) {
          wrapper.classList.add('product-details-tabs__image-wrap');
          wrapper.style.setProperty('display', 'block', 'important');
          wrapper.style.setProperty('float', 'none', 'important');
          wrapper.style.setProperty('box-sizing', 'border-box', 'important');
          wrapper.style.setProperty('width', '100%', 'important');
          wrapper.style.setProperty('max-width', 'none', 'important');
          wrapper.style.setProperty('margin-left', '0', 'important');
          wrapper.style.setProperty('margin-right', '0', 'important');
          wrapper.style.setProperty('padding-left', '0', 'important');
          wrapper.style.setProperty('padding-right', '0', 'important');
          wrapper = wrapper.parentElement;
        }
      });
    }

    activateTab(index, moveFocus = false) {
      const update = () => {
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        if (moveFocus) this.tabs[index].focus();
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    handleKeydown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === index) return;

      event.preventDefault();
      this.activateTab(nextIndex, true);
    }
  }

  if (!customElements.get('product-details-tabs')) {
    customElements.define('product-details-tabs', ProductDetailsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-guide-cta"] && !Shopify.designMode) return;
  try {
    
  if (!window.WNSmarterCleaningScroll) {
    window.WNSmarterCleaningScroll = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.wn-guide [data-wn-guide-scroll]');
      if (!link) return;

      const guide = link.closest('.wn-guide');
      const selector = link.getAttribute('href');
      if (!guide || guide.dataset.wnSmoothScroll !== 'true' || !selector || !selector.startsWith('#')) return;

      const target = document.querySelector(selector);
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.header-wrapper, sticky-header, header[role="banner"]');
      const header_height = header ? header.getBoundingClientRect().height : 0;
      const target_top = target.getBoundingClientRect().top + window.scrollY - header_height - 16;
      const reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: Math.max(0, target_top), behavior: reduced_motion ? 'auto' : 'smooth' });
      window.history.pushState(null, '', selector);
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-guide-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.WNSmarterCleaningScroll) {
    window.WNSmarterCleaningScroll = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.wn-guide [data-wn-guide-scroll]');
      if (!link) return;

      const guide = link.closest('.wn-guide');
      const selector = link.getAttribute('href');
      if (!guide || guide.dataset.wnSmoothScroll !== 'true' || !selector || !selector.startsWith('#')) return;

      const target = document.querySelector(selector);
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.header-wrapper, sticky-header, header[role="banner"]');
      const header_height = header ? header.getBoundingClientRect().height : 0;
      const target_top = target.getBoundingClientRect().top + window.scrollY - header_height - 16;
      const reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: Math.max(0, target_top), behavior: reduced_motion ? 'auto' : 'smooth' });
      window.history.pushState(null, '', selector);
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-guide-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!window.WNSmarterCleaningScroll) {
    window.WNSmarterCleaningScroll = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.wn-guide [data-wn-guide-scroll]');
      if (!link) return;

      const guide = link.closest('.wn-guide');
      const selector = link.getAttribute('href');
      if (!guide || guide.dataset.wnSmoothScroll !== 'true' || !selector || !selector.startsWith('#')) return;

      const target = document.querySelector(selector);
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.header-wrapper, sticky-header, header[role="banner"]');
      const header_height = header ? header.getBoundingClientRect().height : 0;
      const target_top = target.getBoundingClientRect().top + window.scrollY - header_height - 16;
      const reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: Math.max(0, target_top), behavior: reduced_motion ? 'auto' : 'smooth' });
      window.history.pushState(null, '', selector);
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-promo-code-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wn-code-banner')) {
    customElements.define('wn-code-banner', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-copy-button]');
        if (!this.button) return;
        this.label = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[data-copy-status]');
        this.manual = this.querySelector('[data-copy-manual]');
        this.originalLabel = this.label.textContent;
        this.onCopy = () => this.copyCode();
        this.button.addEventListener('click', this.onCopy);
      }
      disconnectedCallback() {
        clearTimeout(this.resetTimer);
        if (this.button && this.onCopy) this.button.removeEventListener('click', this.onCopy);
      }
      legacyCopy() {
        const input = document.createElement('textarea');
        input.value = this.dataset.promoCode;
        input.setAttribute('readonly', '');
        input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;';
        document.body.appendChild(input);
        try {
          input.select();
          input.setSelectionRange(0, input.value.length);
          return document.execCommand('copy');
        } catch { return false; }
        finally { input.remove(); this.button.focus({ preventScroll: true }); }
      }
      async copyCode() {
        if (this.button.disabled || !this.dataset.promoCode) return;
        this.button.disabled = true;
        clearTimeout(this.resetTimer);
        this.manual.hidden = true;
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            try { await navigator.clipboard.writeText(this.dataset.promoCode); copied = true; }
            catch { copied = this.legacyCopy(); }
          } else { copied = this.legacyCopy(); }
          if (!this.isConnected) return;
          this.label.textContent = copied ? this.dataset.copiedLabel : this.originalLabel;
          this.status.textContent = copied ? this.dataset.copiedLabel + ' ' + this.dataset.promoCode : this.dataset.errorLabel;
          if (copied) {
            this.resetTimer = setTimeout(() => {
              this.label.textContent = this.originalLabel;
              this.status.textContent = '';
            }, 4000);
          } else {
            this.manual.hidden = false;
            this.manual.focus({ preventScroll: true });
            this.manual.select();
          }
        } finally { this.button.disabled = false; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wn-sale-countdown')) {
    customElements.define('wn-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const dateMatch = (this.dataset.endDate || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
        const timeMatch = (this.dataset.endTime || '').match(/^(\d{2}):(\d{2})$/);
        if (!dateMatch || !timeMatch) return this.invalid();
        const year = Number(dateMatch[1]);
        const month = Number(dateMatch[2]);
        const day = Number(dateMatch[3]);
        const hour = Number(timeMatch[1]);
        const minute = Number(timeMatch[2]);
        const dateCheck = new Date(Date.UTC(year, month - 1, day));
        if (year < 2000 || dateCheck.getUTCFullYear() !== year || dateCheck.getUTCMonth() !== month - 1 || dateCheck.getUTCDate() !== day || hour > 23 || minute > 59) return this.invalid();
        this.endAt = Date.UTC(year, month - 1, day, hour - 8, minute, 59);
        this.clock = this.querySelector('[data-countdown-clock]');
        this.expired = this.querySelector('[data-countdown-expired]');
        this.deadline = this.querySelector('[data-countdown-deadline]');
        this.link = this.querySelector('[data-countdown-link]');
        this.units = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-countdown-' + unit + ']'));
        this.refresh = () => this.update();
        document.addEventListener('visibilitychange', this.refresh);
        this.update();
        if (Date.now() < this.endAt) this.interval = setInterval(this.refresh, 1000);
      }
      disconnectedCallback() { this.stop(); }
      stop() {
        if (this.interval) clearInterval(this.interval);
        if (this.refresh) document.removeEventListener('visibilitychange', this.refresh);
        this.interval = null;
      }
      invalid() {
        const error = this.querySelector('[data-countdown-error]');
        if (this.dataset.designMode === 'true' && error) error.hidden = false;
        else this.hidden = true;
      }
      update() {
        const seconds = Math.max(0, Math.ceil((this.endAt - Date.now()) / 1000));
        if (seconds === 0) {
          this.stop();
          this.clock.hidden = true;
          this.deadline.hidden = true;
          this.expired.hidden = false;
          if (this.link) this.link.hidden = true;
          if (this.dataset.afterExpiry === 'hide' && this.dataset.designMode !== 'true') this.hidden = true;
          return;
        }
        this.hidden = false;
        this.clock.hidden = false;
        this.expired.hidden = true;
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        values.forEach((value, index) => {
          const text = String(value).padStart(2, '0');
          if (this.units[index].textContent !== text) this.units[index].textContent = text;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-smarter-cleaning-guide"] && !Shopify.designMode) return;
  try {
    
  if (!window.WNSmarterCleaningScroll) {
    window.WNSmarterCleaningScroll = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.wn-guide [data-wn-guide-scroll]');
      if (!link) return;

      const guide = link.closest('.wn-guide');
      const selector = link.getAttribute('href');
      if (!guide || guide.dataset.wnSmoothScroll !== 'true' || !selector || !selector.startsWith('#')) return;

      const target = document.querySelector(selector);
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.header-wrapper, sticky-header, header[role="banner"]');
      const header_height = header ? header.getBoundingClientRect().height : 0;
      const target_top = target.getBoundingClientRect().top + window.scrollY - header_height - 16;
      const reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: Math.max(0, target_top), behavior: reduced_motion ? 'auto' : 'smooth' });
      window.history.pushState(null, '', selector);
      target.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wn-ti-model-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wn-trade-in-showcase')) {
    customElements.define('wn-trade-in-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.cards = Array.from(this.querySelectorAll('.wn-ti-showcase__card'));
        const tablist = this.querySelector('[role="tablist"]');
        if (!this.tabs.length) return;
        tablist.hidden = false;
        const panel = this.querySelector('.wn-ti-showcase__grid');
        panel.setAttribute('role', 'tabpanel');
        this.select = (tab) => {
          this.tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panel.setAttribute('aria-labelledby', tab.id);
          this.cards.forEach(card => { card.hidden = card.dataset.category !== tab.dataset.category; });
          this.querySelector('[data-empty-category]').hidden = this.cards.some(card => !card.hidden);
        };
        tablist.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        });
        tablist.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          const index = this.tabs.indexOf(document.activeElement);
          if (index < 0) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.wn-ti-showcase__card');
          const tab = card && this.tabs.find(item => item.dataset.category === card.dataset.category);
          if (tab) this.select(tab);
        });
        this.select(this.tabs.find(tab => this.cards.some(card => card.dataset.category === tab.dataset.category)) || this.tabs[0]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
